// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"44fffde2","456":"a6d85e46"}[chunkId] + ".chunk.js";
};